import { Component, OnInit } from '@angular/core';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { ItemMetricService } from './item-metric.service'
import { DynamicFieldModel } from '@share';
import { Validators } from '@angular/forms';
import { LoadingService } from 'src/app/share/services/loading.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-item-metric',
  imports: [DynamicTableComponent],
  templateUrl: './item-metric.component.html',
  styleUrl: './item-metric.component.scss'
})
export class ItemMetricComponent implements OnInit {
  total = 0;
  list: any[] = [];
  schema = {
    name: "Item Metric List",
    permissionKey: "itemmetric",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "small",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px"

      },
      {
        key: "name",
        title: "Name",
        type: "string",
        enableSearch: true,
        searchType: "input",
        width: "200px",

      },
      
      {
        key: "mm_name",
        title: "Name (MM)",
        type: "string",
        enableSearch: true,
        searchType: "input",
        width: "200px",

      },
      {
        key: "code",
        title: "Code",
        type: "number",
        enableSearch: true,
        searchType: "input",
        width: "200px",
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name required',
        },
      ],
    },
    {
      label: 'Name (MM)',
      name: 'mm_name',
      type: 'input',
      placeholder: '',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name (MM) required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
    {
      label: 'Code',
      name: 'code',
      type: 'number',
      placeholder: '',

      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Code required',
        }
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    }
  ];

  constructor(private loadingService: LoadingService, private service: ItemMetricService) {
  }

  ngOnInit(): void {
      let params = new HttpParams()
        .set('page', this.schema.pageIndex.toString())
        .set('pageSize', this.schema.pageSize.toString());
      this.loadData(params);
    }
  
    change(data: { [key: string]: any }) {
      let params = new HttpParams()
        .set('page', data['pageIndex'].toString())
        .set('pageSize', data['pageSize'].toString())
        .set('filterValue', JSON.stringify(data['filters']))
        .set('sort', JSON.stringify(data['sorts']));
      this.loadData(params);
    }
  
    loadData(param: HttpParams = null) {
      this.loadingService.toggleTableLoading()
      this.service.getItems(param).subscribe({
        next: x => {
          this.list = x.data;
          this.total = x.totalCount;
        },
        error: err => this.loadingService.toggleTableLoading(),
        complete: () => this.loadingService.toggleTableLoading()
      });
    }
  
    formEvent(data: any) {
      if (data.id) {
        this.service.updateItem(data).subscribe(x => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        });
      }
      else {
        this.service.createItem(data).subscribe(x => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        });
      }
    }
}
